import { isEqual } from 'lodash';
import React from 'react';
import { ComponentStylingInterface, VideoComponentInterface } from '../../../../../interfaces/pagebuilder';

const VideoComponentStyling = ({ component, onChange }: ComponentStylingInterface<VideoComponentInterface>) => {
  return <> </>;
};
export default React.memo(VideoComponentStyling, (prevprop, newprop) => isEqual(prevprop, newprop));
